import React, { useState, useCallback } from "react";
import { updateWorkspaceEnabledStatus } from "../../api/info";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { setWorkspaceInfo } from "../../redux/actions/InfoActions";
import InvalidPage from "../common-components/InvalidPage";

const DisabledWorkspace = () => {
  const dispatch = useDispatch();
  const { organizationId, accountId, workspaceId, token } = useSelector((state) => state.info);
  const { productName } = useSelector((state) => state.info.organization);

  const workspace = useSelector((state) => state.info.workspace);
  const [isLoading, setIsLoading] = useState(false);

  const onReactivate = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await updateWorkspaceEnabledStatus(
        organizationId,
        accountId,
        workspaceId,
        true,
        token
      );
      dispatch(setWorkspaceInfo({ ...workspace, isEnable: true }));
    } catch (error) {
      console.error("Error updating workspace status:", error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, organizationId, accountId, workspaceId, token, workspace]);

  const actionButton = (
    <button
      onClick={onReactivate}
      className="bg-ov-dark-yellow px-4 py-2 rounded-md font-semibold flex justify-center items-center gap-4"
    >
      Reactivate
      {isLoading && <Loader size="18" border="border-4" />}
    </button>
  );

  return (
    <InvalidPage
      image={"/assets/images/disabled.svg"}
      title={`Reactivate your ${productName}`}
      subtitle={`Your ${productName} is currently turned off. Reactivate it to manage your incoming calls and
      maximize business opportunities.`}
      actionButton={actionButton}
    />
  );
};

export default DisabledWorkspace;
